document.addEventListener('DOMContentLoaded', () => {
  const revealElements = document.querySelectorAll('.chillset-reveal');

  if (!revealElements.length) return;

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.16
    }
  );

  revealElements.forEach(element => observer.observe(element));
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.chillset-product-page__quantity-box').forEach(box => {
    const input = box.querySelector('.chillset-qty-input');
    const minus = box.querySelector('[data-qty-minus]');
    const plus = box.querySelector('[data-qty-plus]');

    if (!input || !minus || !plus) return;

    minus.addEventListener('click', () => {
      const current = parseInt(input.value || '1', 10);
      input.value = Math.max(1, current - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    plus.addEventListener('click', () => {
      const current = parseInt(input.value || '1', 10);
      input.value = current + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.chillset-header');

  if (!header) return;

  const toggleHeaderScrolled = () => {
    if (window.scrollY > 16) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  };

  toggleHeaderScrolled();
  window.addEventListener('scroll', toggleHeaderScrolled);
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.chillset-product-page__gift-popover').forEach(popover => {
    const toggle = popover.querySelector('[data-gift-toggle]');
    const panel = popover.querySelector('[data-gift-panel]');
    const close = popover.querySelector('[data-gift-close]');

    if (!toggle || !panel) return;

    toggle.addEventListener('click', event => {
      event.stopPropagation();
      panel.classList.toggle('is-open');
    });

    if (close) {
      close.addEventListener('click', event => {
        event.stopPropagation();
        panel.classList.remove('is-open');
      });
    }

    document.addEventListener('click', event => {
      if (!popover.contains(event.target)) {
        panel.classList.remove('is-open');
      }
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        panel.classList.remove('is-open');
      }
    });
  });
});
// CHILLSET cart total live update fallback
document.addEventListener('DOMContentLoaded', () => {
  const isCartPage = document.querySelector('.chillset-cart-items-shell') || document.querySelector('#main-cart-footer');

  if (!isCartPage) return;

  const formatMoneyEUR = cents => {
    return (cents / 100).toLocaleString('es-ES', {
      style: 'currency',
      currency: 'EUR'
    });
  };

  const updateCartFooterTotal = async () => {
    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!response.ok) return;

      const cart = await response.json();
      const formattedTotal = formatMoneyEUR(cart.total_price);

      document.querySelectorAll('.totals__total-value').forEach(element => {
        element.textContent = formattedTotal;
      });

      document.querySelectorAll('.chillset-header__cart-count').forEach(element => {
        element.textContent = cart.item_count;
      });
    } catch (error) {
      console.warn('CHILLSET cart total update failed', error);
    }
  };

  let updateTimer;

  const scheduleCartUpdate = () => {
    clearTimeout(updateTimer);
    updateTimer = setTimeout(updateCartFooterTotal, 700);
  };

  document.addEventListener('click', event => {
    if (
      event.target.closest('.quantity__button') ||
      event.target.closest('cart-remove-button') ||
      event.target.closest('.cart-remove-button')
    ) {
      scheduleCartUpdate();
    }
  });

  document.addEventListener('change', event => {
    if (
      event.target.matches('.quantity__input') ||
      event.target.closest('.quantity__input')
    ) {
      scheduleCartUpdate();
    }
  });

  updateCartFooterTotal();
});
